export const isMfeMode = import.meta.env.MODE.startsWith('mfe');
